import {clientUrlBuilder} from './utils';
import {
  IPaymeGenerateSaleRequest,
  IPaymeGenerateSaleResponse,
  IPaymeSaveCardRequest,
  IPaymeSaveCardResponse,
  IPaymeSessionResponse
} from "@torim-app/types";

export class ClientApi {
  static async getPaymeSession(
    paymentRequestUuid: string
  ): Promise<IPaymeSessionResponse> {
    const url = clientUrlBuilder({pruid: paymentRequestUuid}, `payment/payme/session`);
    try {
      const response = await fetch(url, {
        method: 'get',
        headers: {
          'content-type': 'application/json'
        },
      });

      if (!response.ok) {
        if ([406, 409].includes(response.status)) throw await response.json();
        throw response.statusText;
      }

      return response.json();
    } catch (e) {
      console.error(e)
      throw e;
    }
  }

  static async generatePaymeSale(
    request: IPaymeGenerateSaleRequest
  ): Promise<IPaymeGenerateSaleResponse> {
    const url = clientUrlBuilder({}, `payment/payme/generate-sale`);
    try {
      const response = await fetch(url, {
        method: 'post',
        headers: {
          'content-type': 'application/json'
        },
        body: JSON.stringify(request)
      });

      if (!response.ok) {
        // 409 carries a reason the form shows (e.g. the booking slot is no longer available)
        if (response.status === 409) throw await response.json();
        throw `Failed to process payment`;
      }

      return response.json();
    } catch (e) {
      console.error(e)
      if ((e as { message?: string })?.message === 'slot-unavailable') throw e;
      throw `Failed to process payment`;
    }
  }

  static async savePaymeCard(
    request: IPaymeSaveCardRequest
  ): Promise<IPaymeSaveCardResponse> {
    const url = clientUrlBuilder({}, `payment/payme/save-card`);
    try {
      const response = await fetch(url, {
        method: 'post',
        headers: {
          'content-type': 'application/json'
        },
        body: JSON.stringify(request)
      });

      if (!response.ok) {
        // 409 carries a reason the form shows (e.g. the booking slot is no longer available)
        if (response.status === 409) throw await response.json();
        throw `Failed to save card`;
      }

      return response.json();
    } catch (e) {
      console.error(e)
      if ((e as { message?: string })?.message === 'slot-unavailable') throw e;
      throw `Failed to save card`;
    }
  }
}
